export default __webpack_public_path__ + "static/brand_top_1-e2ea601ca3e7d95b68978b3cc78a64ee.png";